<template>
  <OnCallPage />
</template>

<script>

import OnCallPage from "./../../../components/NewOnCallPage.vue";

export default {
  name: 'App',
  components: {
    OnCallPage
  }
}
</script>

<style lang="scss">
  @import "./../../../assets/sass/core/ui.scss";
</style>
